import { useCallback } from "react";

import { Descendant, Editor, Element, Transforms } from "slate";

import { Resource } from "@mapmycustomers/shared/types/entity";

import { ResourceLinkElement } from "../../../type/slate-types";
import ElementType from "../../../type/slate/ElementType";
import EmailBodyEditor from "../type/EmailBodyEditor";

const useResourceLinks = (editor: Editor) => {
  const getResourceIds = useCallback(() => {
    const resourceIds = new Set<Resource["id"]>();

    for (const [node] of Editor.nodes(editor, {
      at: [],
      match: (node) =>
        !Editor.isEditor(node) &&
        Element.isElement(node) &&
        node.type === ElementType.RESOURCE_LINK,
    })) {
      const resourceLinkElement = node as ResourceLinkElement;
      resourceIds.add(resourceLinkElement.resourceId);
    }

    return Array.from(resourceIds.values());
  }, [editor]);

  const insertResourceLink = useCallback<EmailBodyEditor["insertResourceLink"]>(
    (resourceId: Resource["id"]) => {
      const resourceLinkNode: Descendant = {
        children: [{ text: "" }],
        resourceId,
        type: ElementType.RESOURCE_LINK,
      };

      Transforms.insertNodes(editor, resourceLinkNode);
    },
    [editor]
  );

  const removeResourceLinks = useCallback<EmailBodyEditor["removeResourceLinks"]>(
    (resourceIds: Resource["id"][]) => {
      Transforms.removeNodes(editor, {
        at: [],
        match: (node) =>
          !Editor.isEditor(node) &&
          Element.isElement(node) &&
          node.type === ElementType.RESOURCE_LINK &&
          resourceIds.includes(node.resourceId),
      });
    },
    [editor]
  );

  return {
    getResourceIds,
    insertResourceLink,
    removeResourceLinks,
  };
};

export default useResourceLinks;
